/**
 * AUTO-SIDE-CONTEXT-MENU
 * Context menu opened from a cell : it opens on the side where it is not cut by the visible area
 * (a cell far on the right of a wide matrix opens the menu toward the left)
 */
import { ComponentProps, useLayoutEffect, useRef, useState } from "react"
import ContextMenu from "@/components/context-menu"
import { getVisibleArea, shouldAlignRight } from "@/utils/get-context-side.utils"

//Width of the context menu in the style sheet
const DEFAULT_WIDTH = 272

function AutoSideContextMenu(props: ComponentProps<typeof ContextMenu>) {
  const anchorRef = useRef<HTMLSpanElement>(null)
  const [alignRight, setAlignRight] = useState<boolean | null>(null)

  //Measured before the first paint : the menu never jumps from one side to the other
  useLayoutEffect(() => {
    const cell = anchorRef.current?.parentElement
    if (!cell) {
      setAlignRight(false)
      return
    }
    const rect = cell.getBoundingClientRect()
    //The matrix can be zoomed out : the menu is as small as the cell
    const scale = cell.offsetWidth ? rect.width / cell.offsetWidth : 1
    setAlignRight(shouldAlignRight(rect, getVisibleArea(cell), (props.width ?? DEFAULT_WIDTH) * scale))
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <span ref={anchorRef} style={{ display: "none" }} />
      {alignRight !== null && <ContextMenu {...props} positionRight={props.positionRight ?? alignRight} />}
    </>
  )
}

export default AutoSideContextMenu
